import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=404ec95c&scoped=true&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"
import style0 from "./Notes.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Notes.vue?vue&type=style&index=1&id=404ec95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ec95c",
  null
  
)

export default component.exports